import { PhoneNumberUtil } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

export const isCountryCodeOnly = (phone: string) => {
  const countryCodes = phoneUtil.getSupportedRegions().map((region) => {
    return phoneUtil.getCountryCodeForRegion(region).toString();
  });

  return countryCodes.some((code) => phone.replace('+', '') === code);
};

export const isPhoneValid = (phone: string) => {
  try {
    return (
      isCountryCodeOnly(phone) || phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone))
    );
  } catch (error) {
    return false;
  }
};
